import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFsms = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 42,
	height: 28,
	viewBox: "0 0 42 28",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#4A5666",
		transform: "translate(-1 -2)",
		children: [
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 10.99,
				cy: 8.66,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2,
				rx: 6.5,
				ry: 4.5
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 35.007,
				cy: 10.21,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2,
				rx: 6.5,
				ry: 4.5
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 20.555,
				cy: 24.464,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2,
				rx: 6.5,
				ry: 4.5
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4A5666",
				strokeWidth: .97,
				d: "m28.66 6.052-4.946-.124 2.078-3.906z"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeWidth: 2,
				d: "M15.73 5.17q4.93-3.148 9.782-.875"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4A5666",
				strokeWidth: .97,
				d: "m12.508 24.71-4.704 1.537 1.15-4.98z"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeWidth: 2,
				d: "M5.786 12C3.47 13.347-.564 22.103 8.942 23.887"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4A5666",
				strokeWidth: .97,
				d: "m36.07 16.393 1.972 3.712-4.89-.687z"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeWidth: 2,
				d: "M27.055 25.587c6.097.78 8.579-4.189 8.7-6.95"
			})
		]
	})
});
export default SvgFsms;
